module.exports = __webpack_public_path__ + "6e5f3fc0f9a2a3dcebc48e9aeb1ed6e2.MP3";